import { render, staticRenderFns } from "./ForumThreadItem.vue?vue&type=template&id=ededd5b8&scoped=true&"
import script from "./ForumThreadItem.vue?vue&type=script&lang=js&"
export * from "./ForumThreadItem.vue?vue&type=script&lang=js&"
import style0 from "./ForumThreadItem.vue?vue&type=style&index=0&id=ededd5b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ededd5b8",
  null
  
)

export default component.exports